import { render, staticRenderFns } from "./Edit-profile.vue?vue&type=template&id=fbe789ca&scoped=true"
import script from "./Edit-profile.vue?vue&type=script&lang=js"
export * from "./Edit-profile.vue?vue&type=script&lang=js"
import style0 from "./Edit-profile.vue?vue&type=style&index=0&id=fbe789ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe789ca",
  null
  
)

export default component.exports